/**
 * Pannello sinistro brand riutilizzabile da L01 (LoginPage) e da future
 * schermate pubbliche (forgot/first-login). Layout aderente allo Stitch
 * 9b81d8a4… ma SENZA i bottoni SSO.
 */
export function BrandPanel() {
  return (
    <section className="hidden md:flex md:w-[55%] login-gradient p-12 flex-col justify-between items-start relative overflow-hidden">
      <div className="z-10 w-full flex flex-col items-center justify-center flex-grow text-center">
        <div className="mb-8">
          <div className="logo-circle shadow-lg mb-6 mx-auto">
            <svg
              className="w-12 h-12"
              fill="none"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M5 20C5 20 10 15 20 20C30 25 35 20 35 20"
                stroke="white"
                strokeLinecap="round"
                strokeWidth="3"
              />
            </svg>
          </div>
          <h2 className="font-headline-lg text-headline-lg text-on-surface max-w-sm mx-auto">
            Il tuo percorso nutrizionale, digitalizzato.
          </h2>
        </div>
      </div>
      <div className="z-10 space-y-6">
        <BenefitRow icon="clinical_notes">
          Gestione pazienti e piani alimentari
        </BenefitRow>
        <BenefitRow icon="calendar_month">
          Agenda e prenotazioni online
        </BenefitRow>
        <BenefitRow icon="receipt_long">
          Fatturazione elettronica integrata
        </BenefitRow>
      </div>
      <div className="absolute -right-24 -bottom-24 w-96 h-96 bg-magenta-soft opacity-40 blur-3xl rounded-full" />
    </section>
  );
}

function BenefitRow({
  icon,
  children,
}: {
  icon: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-4">
      <div className="w-10 h-10 rounded-lg bg-white/60 flex items-center justify-center border border-magenta-soft">
        <span
          className="material-symbols-outlined text-primary"
          aria-hidden="true"
        >
          {icon}
        </span>
      </div>
      <span className="font-body-md text-on-surface-variant font-medium">
        {children}
      </span>
    </div>
  );
}
